/**
 * VersionBadge - Small version indicator for deployment tracking
 * Shows in corner of pages to verify which version is deployed
 */
import React from 'react';
import { APP_VERSION, PAGE_VERSIONS } from '../config/version';

const VersionBadge = ({ page, className = '' }) => {
  const pageVersion = PAGE_VERSIONS[page] || APP_VERSION;
  
  return (
    <div 
      className={`text-[10px] font-mono text-slate-400 opacity-60 hover:opacity-100 transition-opacity ${className}`}
      title={`App v${APP_VERSION} | Page v${pageVersion}`}
    >
      v{pageVersion}
    </div>
  );
};

export default VersionBadge;
